import type { LockPosition } from "../../../../../types/routeBuilder";
import { clampToUnlockedRange } from "./lockUtils";

/** Return the gap in the current list where the dropped visit will land. */
export function getStopDropPreviewIndex(
  routeId: string,
  stops: ReadonlyArray<{ propertyVisitId: string; lock: LockPosition }>,
  propertyVisitId: string,
  target: { type?: unknown; data: Record<string, unknown> } | null | undefined,
): number | null {
  if (target?.data.routeId !== routeId) return null;

  let index: number;
  if (target.type === "stop-slot" && typeof target.data.index === "number") {
    index = target.data.index;
  } else if (target.type === "stop") {
    index = stops.findIndex(
      (stop) => stop.propertyVisitId === target.data.propertyVisitId,
    );
    if (index < 0) return null;
  } else if (target.type === "route-column") {
    index = stops.length;
  } else {
    return null;
  }

  const sourceIndex = stops.findIndex(
    (stop) => stop.propertyVisitId === propertyVisitId,
  );
  index = clampToUnlockedRange(stops, index);
  if (
    sourceIndex >= 0 &&
    (index === sourceIndex || index === sourceIndex + 1)
  ) {
    return null;
  }
  return index;
}

/** Translate a searched list's gap back into the saved list before removing the source. */
export function getStopDropIndex(
  fullIds: string[],
  visibleIds: string[],
  propertyVisitId: string,
  gapIndex: number,
): number {
  const source = fullIds.indexOf(propertyVisitId);
  const visibleSource = visibleIds.indexOf(propertyVisitId);
  // Match the preview's no-op rule so an unchanged drop cannot shift hidden cards.
  if (
    visibleSource >= 0 &&
    (gapIndex === visibleSource || gapIndex === visibleSource + 1)
  ) {
    return source;
  }
  const before = visibleIds[gapIndex];
  const gap = before === undefined ? fullIds.length : fullIds.indexOf(before);
  return gap - (source >= 0 && source < gap ? 1 : 0);
}
